<template>
  <div>
    <BjPage ref="BjPage"
      :label-width="'80px'"
      :default-sort="defaultSort"
      :query-params="queryParams" :col-span="colSpan"
      :get-action="queryApi" :serial="false" :auto-fetch="false"
      :right-toolbar-hide="true"
      :search-btn-hide="true"
      @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @sort-change="sortChange"
      @afterFetchOriginalData="afterFetchOriginalData"
      >
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <vxe-table-column :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :field="col.prop"
            sortable
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'"
            :fixed="col.fixed || false" align="center" class-name="item"
            :title="col.label"
          >
          </vxe-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import { billApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';

export default {
name: 'BillingPageInvoiceReportClient',
mixins: [pageMiXin],
props: {
  value: {
    type: Object,
    default: () => {
      return {};
    },
  }
},
data() {
  return {
    colSpan: 6,
    queryParams: {},
    queryApi: billApi.getInvoiceReportPostage,
    labelList: [
      { label: 'billingPage.Courier', prop: 'courier', isCheck: true, disabled: false },
      { label: 'billingPage.Postage', prop: 'postage', isCheck: true, disabled: false },
      { label: 'billingPage.Cost', prop: 'cost', isCheck: true, disabled: false },
      { label: 'billingPage.GrossProfit', prop: 'grossProfit', isCheck: true, disabled: false },
      { label: 'billingPage.ProfitMargin', prop: 'profitMargin', isCheck: true, disabled: false },
    ],
    defaultSort: [{ 'field': 'courier', 'order': 'desc' }],
  };
},
watch: {
  value: {
    handler(v) {
      this.queryParams = v || null;
    },
    immediate: true,
  },
},
mounted() {
  this.$refs.BjPage.pagingInfo.size = 100;
},
methods: {
  sortChange (column) {
    this.defaultSort = [{ field: column.field, order: column.order }];
    this.$emit('sortChange', column);
  },
  afterFetchOriginalData(res) {
      res.data.dataList.forEach(item => {
        item.postage = `$${item.postage}`;
        item.cost = `$${item.cost}`;
        item.grossProfit = `$${item.grossProfit}`;
        item.profitMargin = `${item.profitMargin}%`;
      });
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = res.data.dataList;
      });
  },
},
};
</script>
